var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconStar01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 10 10"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#999",
  d: "M4.777.463a.241.241 0 0 1 .446 0l1.209 2.908c.035.084.113.14.203.148l3.14.251c.213.018.3.285.137.424L7.521 6.243a.24.24 0 0 0-.078.239l.73 3.063a.241.241 0 0 1-.36.262L5.126 8.166a.24.24 0 0 0-.252 0L2.187 9.807a.241.241 0 0 1-.36-.262l.73-3.063a.24.24 0 0 0-.078-.24L.088 4.195a.241.241 0 0 1 .137-.424l3.14-.251a.24.24 0 0 0 .203-.148z"
})));
export default SvgIconStar01;